import { AirQualityWidgetLazy } from './airQualityWidgetLazy';

const props = [];

export const AirQualityWidgetDirective = reactDirective => reactDirective(AirQualityWidgetLazy, props);
AirQualityWidgetDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('airQualityWidget', AirQualityWidgetDirective);